import React from 'react';
import styled from 'styled-components';

import usePaths from 'src/hooks/use-paths';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

import {
  useSponsoredBrandProductsV2,
  UseSponsoredBrandProductsParams,
} from '../shared/use-sponsored-brand-products-v2';
import { useCarouselTheme } from '../../carousels.utils';

type SponsoredBrandCarouselProps = UseSponsoredBrandProductsParams;

export const SponsoredBrandCarouselV2 = ({
  sponsoredBrandQuery,
  adPlacement,
}: SponsoredBrandCarouselProps): JSX.Element | null => {
  const { dispensary } = useDispensary();
  const { href } = usePaths({ brands: true });
  const carouselTheme = useCarouselTheme(dispensary);

  const {
    error,
    loading,
    products,
    handleProductClick,
    handleQuickAddToCart,
    handleViewAllClick,
    viewportVisibility,
    handleProductImpression,
    brandSlug,
  } = useSponsoredBrandProductsV2({ sponsoredBrandQuery, adPlacement });

  if (!products.length || error) {
    return null;
  }

  if (!brandSlug) {
    console.error('missing brandSlug');
    return null;
  }

  const brandHref = `${href}/${brandSlug}`;

  return (
    // This extra div is just here to account for a child selector removing padding. Once we clean up this flag the div can be removed
    <div data-testid='sponsored-brand-carousel'>
      <Wrapper $bgColor={carouselTheme.backgroundColor}>
        <ProductCarousel
          ref={viewportVisibility.ref}
          products={products}
          isLoading={loading}
          title='Featured Brand'
          subTitle='Sponsored'
          href={brandHref}
          mt='0'
          gradientColor={carouselTheme.backgroundColor}
          onViewAllClick={handleViewAllClick}
          onProductClick={handleProductClick}
          onQuickAddToCart={handleQuickAddToCart}
          onProductView={handleProductImpression}
          hideSponsoredTag
          isBottomSubTitle
        />
      </Wrapper>
    </div>
  );
};

const Wrapper = styled.div<{ $bgColor?: string }>`
  background-color: ${({ $bgColor }) => $bgColor};
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  padding: 20px 20px 0;
`;
